<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.29047 2.10931C7.62178 1.9564 8 2.1984 8 2.56329V19.4375C8 19.8024 7.62178 20.0444 7.29047 19.8915L2.79047 17.8145C2.6134 17.7328 2.5 17.5556 2.5 17.3605V14.0004H1.5V17.3605C1.5 17.9456 1.84019 18.4773 2.37141 18.7225L6.87141 20.7994C7.86534 21.2581 9 20.5322 9 19.4375V2.56329C9 1.4686 7.86534 0.742615 6.87141 1.20135L2.37141 3.27827C1.84019 3.52346 1.5 4.05514 1.5 4.64021V8.00038H2.5V4.64021C2.5 4.44519 2.6134 4.26796 2.79047 4.18623L7.29047 2.10931Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7095 2.10931C14.3782 1.9564 14 2.1984 14 2.56329V19.4375C14 19.8024 14.3782 20.0444 14.7095 19.8915L19.2095 17.8145C19.3866 17.7328 19.5 17.5556 19.5 17.3605V14.0004H20.5V17.3605C20.5 17.9456 20.1598 18.4773 19.6286 18.7225L15.1286 20.7994C14.1347 21.2581 13 20.5322 13 19.4375V2.56329C13 1.4686 14.1347 0.742615 15.1286 1.20135L19.6286 3.27827C20.1598 3.52346 20.5 4.05514 20.5 4.64021V8.00038H19.5V4.64021C19.5 4.44519 19.3866 4.26796 19.2095 4.18623L14.7095 2.10931Z" fill="currentColor"/>
        <path d="M16 11H20M20 11L18 9M20 11L18 13" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 11H2M2 11L4 9M2 11L4 13" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGOpenDoors',
};
</script>

<style scoped lang="scss">

</style>
